import { Fragment, useEffect, useState } from 'react';
import { NewPaymentMethod, PaymentMethodsList, Title, Wrapper } from './PaymentMethodsWrapper.styled';
import { useDispatch, useSelector } from 'react-redux';

import { CreatePaymentMethod } from '../Forms';
import { PaymentMethodItem } from './PaymentMethodItem';
import { retreivePaymentMethods, setDefaultMethod } from '../../api/paymentMethods';
import { setPaymentMethods } from '../../store/paymentMethods/paymentMethodsSlice';
import type { state } from '../../types/store/state';
import { useTranslation } from 'next-i18next';

interface Props {
  condensed: boolean;
}

export const PaymentMethodsWrapper = ({ condensed }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const paymentMethods = useSelector(({ paymentMethods }: state) => paymentMethods.results);

  const [showAddPayment, setShowAddPayment] = useState(false);

  const handleClick = (event: any) => {
    event.preventDefault();
    setShowAddPayment(!showAddPayment);
  };

  useEffect(() => {

    retreivePaymentMethods()
      .then(async (res) => {
        dispatch(setPaymentMethods(res));

        const hasPrimary = res.results.some((method: any) => method.primary);

        if (!hasPrimary && res.results.length > 0) {
          const firstMethod = res.results[0];
          try {
            await setDefaultMethod({ id: firstMethod.id });
            const updatedMethods = await retreivePaymentMethods();
            dispatch(setPaymentMethods(updatedMethods));
          } catch (error) {
            console.error('Error setting first method as primary:', error);
          }
        }
      })
      .catch((error) => {
        throw new Error(error);
      });
  }, []);

  return (
    <Wrapper>
      {!condensed ? (
        <Title>
          {t('payment.methods.title')}
        </Title>
      ) : null}
      <PaymentMethodsList>
        {paymentMethods.map((method) =>
          <Fragment key={method.id}>
            <PaymentMethodItem {...method} condensed={condensed} />
          </Fragment>
        )}
      </PaymentMethodsList>
      <NewPaymentMethod onClick={handleClick}>
        {showAddPayment ? '-' : '+'} {t('payment.action.addPayMethods')}
      </NewPaymentMethod>
      {showAddPayment ? (
        <CreatePaymentMethod setShowAddPayment={setShowAddPayment} />
      ) : null}
    </Wrapper>
  );
};
